import React, { useState, useEffect } from "react";

const TimelinePanels = ({ panels, getContent }) => {
    const [activePanels, setActivePanels] = useState([]);
    const [panelContent, setPanelContent] = useState({});

    const togglePanel = (panel) => {
        setActivePanels((prevPanels) =>
            prevPanels.includes(panel)
                ? prevPanels.filter((p) => p !== panel)
                : [...prevPanels, panel]
        );
    };

    useEffect(() => {
        const fetchContent = async () => {
            const newContent = {};

            for (const panel of activePanels) {
                newContent[panel] = await getContent(panel);
            }

            setPanelContent(newContent);
        };

        fetchContent();
    }, [activePanels, getContent]);

    return (
        <div className="panel-group" id="accordion" role="tablist" aria-multiselectable="true">
            {panels.map((panel) => {
                const panelId = `c${panel.substring(0, 4)}`;
                const headingId = `h${panel.substring(0, 4)}`;
                const isActive = activePanels.includes(panel);

                return (
                    <div key={panel} className="panel panel-default panel-box">
                        <div className="panel-heading" role="tab" id={headingId}>
                            <h4 className="panel-title">
                                <button
                                    className="btn panel-title-btn"
                                    onClick={() => togglePanel(panel)}
                                >
                                    <strong>{panel}</strong>
                                </button>
                            </h4>
                        </div>
                        {isActive && (
                            <div id={panelId} className="panel-collapse in" role="tabpanel">
                                <div className="panel-body">
                                    <div dangerouslySetInnerHTML={{ __html: panelContent[panel] || "" }} />
                                </div>
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default TimelinePanels;
